// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// import { Application } from "@hotwired/stimulus"
// import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// window.Stimulus = Application.start()
// const context = require.context("./controllers", true, /\.js$/)
// Stimulus.load(definitionsFromContext(context))

import Swal from 'sweetalert2/dist/sweetalert2.all.js'
import 'sweetalert2/src/sweetalert2.scss'
import '../styles/site-swal.scss'
import '../styles/exhibitor-copy-dossier-link.scss'
import '../styles/registration-field-tooltips.scss'
import { initSiteSwal, showSiteAlert } from 'packs/init-site-swal'
import { initExhibitorRegistrationCopy } from 'packs/registration-checkbox'

window.Swal = Swal
window.showSiteAlert = showSiteAlert
window.initExhibitorRegistrationCopy = initExhibitorRegistrationCopy
initSiteSwal()

import Rails from "@rails/ujs"
window.Rails = Rails;
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

require("@fortawesome/fontawesome-free/js/all")

import { infosPratiquesOnglets } from 'packs/infos-pratiques'
import { initSelectStands, initRegistrationStandsSelection } from 'packs/init-select-stands'
import { initStandsLayoutNavbarHide } from 'packs/init-stands-layout-navbar'
import { modalAction } from 'packs/modals'
import { initUpdateCommandsPrices } from 'packs/init-update-commands-prices'
import { initFormValidation } from 'packs/init-form-validation'
import { initCsrfSync } from 'packs/init-csrf-sync'
import { navbarAction } from 'packs/navbar-mobile'
import { infosFormatMobile } from 'packs/infos-pratiques'
import { espaceUserMenuMobile, initBadgesInviteCopy } from 'packs/espace-user'
import { keepFlashMessagesBesideNavBar } from 'packs/flashes-position'
import { autoSubmitSearchForm } from 'packs/auto-submit-search-form'
import { makePlaceholdersDisappear } from 'packs/placeholder-handler'
import { initHallChangeConfirmation } from 'packs/init-hall-change-confirmation'
import { initBackofficeFlatpickr } from 'packs/init-backoffice-flatpickr'
import { initBackofficeAutosave } from 'packs/init-backoffice-autosave'
import { initBackofficeFlashes } from 'packs/init-backoffice-flashes'
import { initBackofficeCopy } from 'packs/init-backoffice-copy'
import { initBackofficeStandsPlan } from 'packs/init-backoffice-stands-plan'
import { initBackofficeFileInputs } from 'packs/init-backoffice-file-inputs'
import { initBackofficeImagePreview } from 'packs/init-backoffice-image-preview'
import { initBackofficeContentDocuments } from 'packs/init-backoffice-content-documents'
import { initBackofficePartnerLogos } from 'packs/init-backoffice-partner-logos'
import { initBackofficeContentPhotos } from 'packs/init-backoffice-content-photos'
import { initBackofficeRegistrationOptions } from 'packs/init-backoffice-registration-options'
import { initBackofficeFaq } from 'packs/init-backoffice-faq'
import { initBackofficeAmenities } from 'packs/init-backoffice-amenities'
import { initBackofficeRailsConfirm } from 'packs/init-backoffice-confirm'
import { initBackofficeAutoSearch } from 'packs/init-backoffice-auto-search'
import { initBackofficeParticipantsDateFilter } from 'packs/init-backoffice-participants-date-filter'
import { initBackofficeParticipantsStatusFilters } from 'packs/init-backoffice-participants-status-filters'
import { initBackofficeParticipantsCatalogueFilter } from 'packs/init-backoffice-participants-catalogue-filter'
import { initBackofficeParticipantsBulk } from 'packs/init-backoffice-participants-bulk'
import { initBackofficeParticipantsExport } from 'packs/init-backoffice-participants-export'
import { initBackofficeParticipantsPerPage } from 'packs/init-backoffice-participants-per-page'
import { initBackofficeSelectDropdown } from 'packs/init-backoffice-select-dropdown'
import { initFormFileField } from 'packs/init-form-file-field'
import { initBackofficeMailerHeaderPicker } from 'packs/init-backoffice-mailer-header-picker'
import { initBackofficeRichText } from 'packs/init-backoffice-rich-text'
import { initBackofficeCountdown } from 'packs/init-backoffice-countdown'
import { initBackofficeEditionSwitcher } from 'packs/init-backoffice-edition-switcher'
import { initBackofficeNavCollapse } from 'packs/init-backoffice-nav-collapse'
import { initBackofficeHeaderTooltips } from 'packs/init-backoffice-header-tooltips'
import { initBackofficeTableTooltips } from 'packs/init-backoffice-table-tooltips'
import { initBackofficeTableRowLinks } from 'packs/init-backoffice-table-row-links'
import { initBackofficeHeaderMore } from 'packs/init-backoffice-header-more'
import { initBackofficePendingActions } from 'packs/init-backoffice-pending-actions'
import { initBackofficeRegistrationReview } from 'packs/init-backoffice-registration-review'
import { initBackofficeUnsavedWarn } from 'packs/init-backoffice-unsaved-warn'
import { initBackofficeParticipantFormReveals } from 'packs/init-backoffice-participant-form-reveals'
import { initAdminPasswordRules } from 'packs/init-admin-password-rules'
import { initWizardBoothStaff } from 'packs/init-wizard-booth-staff'
import { initBackofficeNotificationRows } from 'packs/init-backoffice-notification-rows'
import { initBackofficeSettings } from 'packs/init-backoffice-settings'

Rails.start()
initCsrfSync()
initBackofficeRailsConfirm()
Turbolinks.start()
ActiveStorage.start()

// External imports
import "bootstrap";

const runBoot = (fn) => {
  try {
    fn()
  } catch (error) {
    console.error("[backoffice boot]", error)
  }
}

document.addEventListener('turbolinks:load', () => {
  // Dirty guard tôt : ne doit pas dépendre des autres inits.
  runBoot(initBackofficeUnsavedWarn)

  runBoot(infosPratiquesOnglets)
  runBoot(initSelectStands)
  runBoot(initRegistrationStandsSelection)
  runBoot(initStandsLayoutNavbarHide)
  runBoot(modalAction)
  runBoot(initUpdateCommandsPrices)
  runBoot(initFormValidation)
  runBoot(navbarAction)
  runBoot(infosFormatMobile)
  runBoot(espaceUserMenuMobile)
  runBoot(initBadgesInviteCopy)
  runBoot(keepFlashMessagesBesideNavBar)
  runBoot(initExhibitorRegistrationCopy)
  runBoot(autoSubmitSearchForm)
  runBoot(makePlaceholdersDisappear)
  runBoot(initHallChangeConfirmation)
  runBoot(initBackofficeFlatpickr)
  runBoot(initBackofficeAutosave)
  runBoot(initBackofficeFlashes)
  runBoot(initBackofficeCopy)
  runBoot(initBackofficeStandsPlan)
  runBoot(initBackofficeFileInputs)
  runBoot(initBackofficeImagePreview)
  runBoot(initBackofficeContentDocuments)
  runBoot(initBackofficePartnerLogos)
  runBoot(initBackofficeContentPhotos)
  runBoot(initBackofficeRegistrationOptions)
  runBoot(initBackofficeFaq)
  runBoot(initBackofficeAmenities)
  runBoot(initBackofficeAutoSearch)
  runBoot(initBackofficeParticipantsDateFilter)
  runBoot(initBackofficeParticipantsStatusFilters)
  runBoot(initBackofficeParticipantsCatalogueFilter)
  runBoot(initBackofficeParticipantsBulk)
  runBoot(initBackofficeParticipantsExport)
  runBoot(initBackofficeParticipantsPerPage)
  runBoot(initBackofficeSelectDropdown)
  runBoot(initFormFileField)
  runBoot(initBackofficeMailerHeaderPicker)
  runBoot(initBackofficeRichText)
  runBoot(initBackofficeCountdown)
  runBoot(initBackofficeEditionSwitcher)
  runBoot(initBackofficeNavCollapse)
  runBoot(initBackofficeHeaderTooltips)
  runBoot(initBackofficeTableTooltips)
  runBoot(initBackofficeTableRowLinks)
  runBoot(initBackofficeHeaderMore)
  runBoot(initBackofficePendingActions)
  runBoot(initBackofficeRegistrationReview)
  runBoot(initBackofficeParticipantFormReveals)
  runBoot(initAdminPasswordRules)
  runBoot(initWizardBoothStaff)
  runBoot(initBackofficeNotificationRows)
  runBoot(initBackofficeSettings)
});
